import { DtoV1ContactContact } from '~/__generated__/api';

export function getNameForContact(contact?: DtoV1ContactContact) {
  return `${contact?.firstName ?? ''} ${contact?.lastName ?? ''}`.trim();
}
